import { useState } from "react";
import { Play } from "lucide-react";

const BOOK_COVER =
  "https://customer-assets.emergentagent.com/job_growth-journey-146/artifacts/chjevp64_FF9B91FB-B06E-4F28-81AD-9DBE4D3D8B14.jpeg";

// Author intro video.
const VIDEO_SRC =
  "https://customer-assets.emergentagent.com/job_growth-journey-146/artifacts/sft39qm9_My30DG_ad_5MB.MP4";

export default function VideoIntro() {
  const [playing, setPlaying] = useState(false);

  return (
    <section
      id="intro-video"
      data-testid="intro-video-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37]/80">
            Discipline creates transformation
          </p>
          <h2 className="font-serif-display mt-4 text-4xl sm:text-5xl text-white leading-[1.05] tracking-tight uppercase">
            Your journey <em className="gold-text">starts today.</em>
          </h2>
        </div>

        <div className="relative group">
          {/* gold ambient glow */}
          <div className="absolute -inset-6 bg-[#d4af37]/10 blur-3xl rounded-3xl pointer-events-none" />

          <div className="relative aspect-video rounded-2xl overflow-hidden border border-[#d4af37]/25 bg-[#0e0e0e]">
            {playing && VIDEO_SRC ? (
              <video
                src={VIDEO_SRC}
                autoPlay
                controls
                playsInline
                data-testid="intro-video-player"
                className="w-full h-full object-contain bg-black"
              />
            ) : (
              <button
                type="button"
                onClick={() => setPlaying(true)}
                disabled={!VIDEO_SRC}
                data-testid="intro-video-play-btn"
                className="absolute inset-0 w-full h-full group/btn"
                aria-label="Play intro video"
              >
                {/* Poster — book cover dimmed */}
                <img
                  src={BOOK_COVER}
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover opacity-30"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/80" />

                {/* Center play badge */}
                <div className="relative h-full flex flex-col items-center justify-center">
                  <span className="relative flex items-center justify-center">
                    <span className="absolute w-28 h-28 rounded-full bg-[#d4af37]/20 animate-ping" />
                    <span className="relative w-20 h-20 rounded-full bg-[#d4af37] text-black flex items-center justify-center shadow-[0_0_60px_rgba(212,175,55,0.5)] group-hover/btn:scale-110 transition-transform">
                      <Play className="w-7 h-7 ml-1 fill-current" />
                    </span>
                  </span>
                  <p className="mt-6 font-serif-display text-2xl text-white">
                    {VIDEO_SRC ? "Watch Now" : "Video coming soon"}
                  </p>
                  {!VIDEO_SRC && (
                    <p className="mt-1 text-xs uppercase tracking-[0.25em] text-[#d4af37]/80">
                      Upload pending
                    </p>
                  )}
                </div>
              </button>
            )}
          </div>

          {/* gold corner accents */}
          <span className="absolute -top-2 -left-2 w-10 h-10 border-t-2 border-l-2 border-[#d4af37] pointer-events-none" />
          <span className="absolute -bottom-2 -right-2 w-10 h-10 border-b-2 border-r-2 border-[#d4af37] pointer-events-none" />
        </div>
      </div>
    </section>
  );
}
